import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './msalConfig';

/** Starts the Entra sign-in redirect. Ignores clicks while another MSAL interaction is running. */
export const useSignIn = () => {
  const { instance, inProgress } = useMsal();
  return () => {
    if (inProgress !== InteractionStatus.None) return;
    void instance.loginRedirect(loginRequest);
  };
};
